import random from 'lodash/random';
import { NonEmpty } from './NonEmpty';

export const rand = <T>(arr: NonEmpty<T>): T => {
  return arr[random(arr.length - 1)];
};
